/* eslint-disable @typescript-eslint/no-explicit-any */

import { Auth } from "aws-amplify";
import Axios, { AxiosInstance, AxiosRequestConfig } from "axios";

const windowFork = window;

const $http: AxiosInstance = Axios.create({
	baseURL: windowFork.config.REACT_APP_API_URL,
});

$http.interceptors.request.use(
	(config: AxiosRequestConfig) =>
		new Promise((resolve, reject) => {
			Auth.currentSession()
				.then((session) => {
					const idTokenExpire = session.getIdToken().getExpiration();
					const refreshToken = session.getRefreshToken();
					const currentTimeSeconds = Math.round(+new Date() / 1000);
					if (idTokenExpire < currentTimeSeconds) {
						Auth.currentAuthenticatedUser().then((res) => {
							res.refreshSession(refreshToken, (err: any, data: any) => {
								if (err) {
									Auth.signOut().then(() => {
										window.location.href = '/';
									});
									reject(err);
								} else {
									(config.headers as any).Authorization = `Bearer ${data
										.getIdToken()
										.getJwtToken()}`;
									resolve(config);
								}
							});
						});
					} else {
						(config.headers as any).Authorization = `Bearer ${session
							.getIdToken()
							.getJwtToken()}`;
						resolve(config);
					}
				})
				.catch((err) => {
					// Session invalid (disabled user, revoked tokens, etc.) — force logout
					if (err === 'No current user' || err?.message?.includes('NotAuthorizedException') || err?.message?.includes('disabled')) {
						Auth.signOut().then(() => {
							window.location.href = '/';
						});
						reject(err);
						return;
					}
					resolve(config);
				});
		})
);

export default $http;
